<header class="toolbar" role="banner">
  <span class="page-title">{{ pageTitle() }}</span>
  <button
    class="profile-btn"
    mat-icon-button
    aria-label="Profile"
    data-testid="profile-btn"
    type="button"
    (click)="onProfileClick()">
    <mat-icon class="mat-icon-filled profile-icon">account_circle</mat-icon>
  </button>
</header>
